<div class="body">
    
    <ng-container *ngIf="filter">

        <div class="content">

            <div *ngFor="let condition of criteria; let i = index" class="condition-body">

                <div *ngIf="i > 0" class="operator">
                    {{operator}}
                </div>
    
                <div>
                    {{condition.attribute}}
                </div>

                <span class="operator" [ngSwitch]="condition.operation">

                    <span *ngSwitchCase="FilterConditionOperation.EQUAL"> ist gleich </span>
                    <span *ngSwitchCase="FilterConditionOperation.UNEQUAL"> ist ungleich </span>
                    <span *ngSwitchCase="FilterConditionOperation.INCLUDES"> enthält </span>
                    <span *ngSwitchCase="FilterConditionOperation.INCLUDESNOT"> enthält nicht </span>

                </span>
    
                <div>
                    {{condition.value}}
                </div>
    
            </div>

            <div *ngFor="let child of filter.filteR1; let i = index">

                <div *ngIf="filter.filtercondition.length > 0 || i > 0" class="operator">
                    {{operator}}
                </div>

                <app-filter-structure-preview [filter]="child"></app-filter-structure-preview>

            </div>

        </div>
        
    </ng-container>
    
</div>